import React, { useEffect, useState } from "react";
import AppCard from "../../../shared/components/AppCard";
import { Button, Table, Modal, Popconfirm, Tooltip } from "antd";
import {
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import "./CustomtagsList.scss";
import { CustomTags } from "../../../models/CustomTags/customTags.model";
import CustomTagsForm from "../CustomTagsForm";
import TagService from "../../../services/TagService/tag.service";
import AppLoader from "../../../shared/components/AppLoader";
import {UserRoleEnum} from "../../../enums/userRole.enum";

interface CustomTagsListProps {}

function CustomTagsList(props: CustomTagsListProps) {
  const [customTags, setCustomTags] = useState<CustomTags[]>([]);

  const [showCustomTagForm, setShowCustomTagForm] = useState(false);

  const [activeCustomTag, setActiveCustomTag] = useState(new CustomTags());

  const [loading, setLoading] = useState(false);

  const handleCloseCustomTagForm = () => setShowCustomTagForm(false);

  const handleAddCustomTag = () => {
    setActiveCustomTag(new CustomTags());
    setShowCustomTagForm(true);
  };

  const handleDeleteCustomTag = (customTag: CustomTags) => {
    // console.log(customTag);
  };

  const handleCustomTagFormSuccess = (customTag: CustomTags) => {
    setShowCustomTagForm(false);
    handleFetchCustomTags();
  };

    const handleFetchCustomTags = () => {
        setLoading(true);

        TagService.fetchAdminTags(
            UserRoleEnum.ADMIN,
            (customTags: CustomTags[]) => {
                setCustomTags(customTags);
                setLoading(false);
            },
            () => {
                setLoading(false);
            },
            () => {
                setLoading(false);
            }
        );
    };


    useEffect(() => {
    handleFetchCustomTags();
  }, []);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
        title: "Color",
        dataIndex: "color",
        key: "color",
        render: (color: string) => (
          <div
              style={{
                  width: 24,
                  height: 24,
                  backgroundColor: color,
                  borderRadius: 4,
                  border: "1px solid #d9d9d9",
              }}
          />
        ),
    },
    {
      title: "Action",
      key: "action",
      render: (text: string, customTag: CustomTags) => {
        return (
          <div className="customTag-list_actions">
            <Tooltip title="Edit Custom Tags">
              <EditOutlined
                onClick={() => {
                  setShowCustomTagForm(true);
                  setActiveCustomTag(customTag);
                }}
              />
            </Tooltip>
          </div>
        );
      },
      width: 150,
    },
  ];

  return (
    <div className="customTag-list">
      <AppCard>
        <h2>
          Custom Tags
          <Button
            type="primary"
            className="float-right"
            onClick={handleAddCustomTag}
          >
            <PlusOutlined />
            Add Custom Tags
          </Button>
        </h2>
        {loading ? (
          <AppLoader loading={loading} />
        ) : (
          <Table dataSource={customTags} columns={columns} />
        )}
      </AppCard>
      <Modal
        className="primary-modal"
        footer=""
        keyboard={false}
        maskClosable={false}
        destroyOnClose
        visible={showCustomTagForm}
        onCancel={handleCloseCustomTagForm}
      >
          {activeCustomTag && (
              <CustomTagsForm
                  customTags={activeCustomTag}
                  onSuccess={handleCustomTagFormSuccess}
              />
          )}
      </Modal>
    </div>
  );
}

export default CustomTagsList;
